import { all, takeLatest } from 'redux-saga/effects';
import domainsSaga from '../components/DomainDetails/saga';
import domainComponentsSaga from '../components/DomainElements/saga';
import errorCodeSaga from '../common/redux/errorCodeHandler/saga';
import eventDropdownLevelsSaga from '../common/redux/eventDropdownLevel/saga';
import canbusTroubleshootSaga from '../common/redux/canbusTroubleshooter/saga';
import googleAnalyticTrackingSaga from '../common/redux/googleAnalyticTracking/saga';
import canbusTroubleshootTutorialSaga from '../common/redux/canbusTroubleshooterTutorial/saga';
import entityKpiDetailsSaga from '../common/components/KpiGrid/saga';
import featureFlagSaga from '../common/redux/FeatureFlag/saga';
import dataChartSaga from '../components/DataCharts/sagas/dataChartSaga';
import dataChartEventsSaga from '../components/DataCharts/sagas/dataChartEventsSaga';
import dataChartConfigurationSaga from '../components/DataCharts/sagas/dataConfigChartSaga';
import vectorDataChartSaga from '../components/Vector/sagas/vectorDataChartSaga';
import vectorConfigurationSaga from '../components/Vector/sagas/vectorConfigurationSaga';
import updateLanguageSaga from '../common/components/Translation/saga';
import milkJarSaga from '../components/DataCharts/sagas/milkJarSaga';
import eventsLevelMenuOptionsSaga from '../common/redux/eventDropdownLevelMenuOptions/saga';
import updateHistorySaga from '../components/UpdatesHistory/sagas/updateHistorySaga';
import updateHistorySagaForSystem from '../components/UpdatesHistory/sagas/updateHistorySagaForSystem';
import kpiSaga from '../components/PerformanceIndicators/kpiSaga';
import translationSaga from '../common/i18n/translationSaga';
import { postLoginActions } from './postLoginSaga';

// Api's
import { api as eventsApi } from '../api/lelyBackend/eventsApi';
import { api as domainsApi } from '../api/lelyBackend/domainsApi';
import { api as logsApi } from '../api/lelyBackend/logsApi';
import { api as troubleshootApi } from '../api/lelyBackend/troubleshootApi';
import { api as entityKpiDetailsApi } from '../api/lelyBackend/entityKpiDetailsApi';
import { api as dataChartsApi } from '../api/lelyBackend/dataChartsApi';
import { api as vectorConfigurationApi } from '../api/lelyBackend/vectorConfigurationApi';
import { api as updateLelyPreferredLanguage } from '../api/lelyBackend/translationApi';
import { api as updateHistoryApi } from '../api/lelyBackend/updateHistoryApi';
import { api as kpiApi } from '../api/lelyBackend/kpiDataApi';
import { api as userDetailsApi } from '../api/lelyBackend/userDetails';

// Mock api's
import { setNetworkError } from '../reducers/networkErrorSlice';
import { fetchFeatureFlags } from '../reducers/featureFlagSlice';
import logsFilterMenuSaga from '../components/LogsFilterMenu/logsFilterMenuSaga';
import logsContentSaga from '../components/LogsContentArea/logsContentSaga';
import logsDownloadSaga from '../components/LogsFilterMenu/logsDownloadSaga';
import logsFilterDownloadModalSaga from '../components/LogsFilterMenu/logsFilterDownloadModalSaga';
import getUserDetailsSaga from '../common/components/UserDetails/getUserDetailsSaga';
import getLanguagesRequest from '../common/components/Translation/getLanguagesSaga';
import { getLanguages } from '../reducers/translationSlice';

/** Root saga.
 * @return {Object} - return store
 */
function* rootSaga() {
  yield all([
    domainsSaga(domainsApi),
    domainComponentsSaga(domainsApi),
    logsFilterMenuSaga(logsApi),
    logsContentSaga(logsApi),
    logsDownloadSaga(logsApi),
    logsFilterDownloadModalSaga(logsApi),
    takeLatest(setNetworkError.type, errorCodeSaga),
    eventDropdownLevelsSaga(eventsApi),
    canbusTroubleshootSaga(troubleshootApi),
    canbusTroubleshootTutorialSaga(troubleshootApi),
    googleAnalyticTrackingSaga(),
    entityKpiDetailsSaga(entityKpiDetailsApi),
    dataChartSaga(dataChartsApi),
    dataChartEventsSaga(dataChartsApi),
    dataChartConfigurationSaga(dataChartsApi),
    vectorDataChartSaga(dataChartsApi),
    vectorConfigurationSaga(vectorConfigurationApi),
    takeLatest(fetchFeatureFlags.type, featureFlagSaga),
    updateLanguageSaga(updateLelyPreferredLanguage),
    takeLatest(getLanguages.type, getLanguagesRequest), // TODO: Remove this once we have a way to get the languages from the user details
    postLoginActions(),
    eventsLevelMenuOptionsSaga(dataChartsApi),
    updateHistorySaga(updateHistoryApi),
    updateHistorySagaForSystem(updateHistoryApi),
    milkJarSaga(dataChartsApi),
    kpiSaga(kpiApi),
    translationSaga(),
    getUserDetailsSaga(userDetailsApi),
  ]);
}

export default rootSaga;
